/**
 * クラス名：ログイン画面
 * 説明：システムログイン画面である。
 * 作成者：ナンス
 * 作成日：2023/03/01
 * バージョン：1.0
 */
import { Form, Input, Button, Image, Alert, Layout, Space, Typography } from 'antd';
import React, { forwardRef, useEffect, useState } from 'react';
import { StatusCodes } from 'http-status-codes';

import { WithRouter } from '../components/WithRouter';
import { ErrorMessage } from './common/Message';
import { Content } from 'antd/es/layout/layout';
import login_icon from '../assets/images/login_icon.png';
import { error } from './common/CommonModal';
import logo from '../assets/images/logo.ico';

const ChangePassword = forwardRef((props, ref) => {
  const formRef = React.useRef(null);
  let params = new URLSearchParams(window.location.search);
  const [errorMessage, setErrorMessage] = useState(params.has('ErrorMessage') ? params.get('ErrorMessage') : '');

  useEffect(() => {}, []);

  // ログインボタンの押下
  const handleSubmit = async (values) => {
    let loginId = values?.loginId;
    let oldPassword = values?.oldPassword;
    let newPassword = values?.newPassword;
    changePwd(loginId, oldPassword, newPassword);
  };

  // パスワード更新処理
  const changePwd = async (loginId, oldPassword, newPassword) => {
    // 必須チェック
    if (!loginId || !oldPassword || !newPassword) {
      setErrorMessage(ErrorMessage().E005);
      return;
    }
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Auth/PutUserMaster';
      const otherParam = {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          mailAddress: loginId,
          oldPassword: oldPassword,
          newPassword: newPassword,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then(async (data) => {
          if (data && data?.statusCode === StatusCodes.OK) {
            // 正常の場合、
            window.location.href = 'login';
          } else if (
            data &&
            (data?.statusCode === StatusCodes.UNAUTHORIZED || data?.statusCode === StatusCodes.CONFLICT)
          ) {
            setErrorMessage(ErrorMessage()['E024']);
          } else if (data && data?.statusCode !== StatusCodes.OK) {
            // 異常の場合、
            setErrorMessage(ErrorMessage()[data?.messageCode]);
          }
        })
        .catch((error) => {
          // 異常の場合、
          setErrorMessage(ErrorMessage().E010);
        });
    } catch (e) {
      error(e.message);
    }
  };

  return (
    <div style={{ overflow: 'hidden' }}>
      <Layout>
        {/* ヘッダー */}
        <div style={{ backgroundColor: '#1063aa', display: 'flex', alignItems: 'center', height: '5vh' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'center',
              width: '60%',
            }}
          >
            <Space size="large">
              <Image preview={false} width={35} src={logo} style={{ marginLeft: '5px', marginTop: '0px' }}></Image>
              <h5
                style={{
                  color: 'whitesmoke',
                  marginLeft: '-13px',
                  marginTop: '3px',
                  fontWeight: 'bold',
                  color: 'gold',
                }}
              >
                ZeroFour System
              </h5>
            </Space>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'right',
              alignItems: 'center',
              width: '39%',
            }}
          >
            {/* ログイン */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => (window.location.href = 'login')}
            >
              <Image preview={false} width={24} src={login_icon}></Image>
              <Typography.Text
                className="menu-active-hover"
                ellipsis={{ tooltip: ['ログイン'] }}
                style={{
                  color: 'whitesmoke',
                  marginLeft: '0px',
                  fontSize: '14px',
                  marginRight: '20px',
                  fontWeight: 'bold',
                }}
              >
                ログイン
              </Typography.Text>
            </div>
          </div>
        </div>
        <Layout
          style={{
            background: 'white',
            left: 0,
          }}
        >
          {/* コンテンツ */}
          <Content style={{ overflow: 'initial' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '60px',
                // overflowX: 'hidden',
                // overflowY: 'hidden',
              }}
            >
              <Form
                name="Login"
                onFinish={handleSubmit}
                ref={formRef}
                layout="vertical"
                style={{ maxWidth: '500px', height: '100%' }}
                initialValues={{
                  loginId: '',
                  oldPassword: '',
                  newPassword: '',
                }}
              >
                {/* ユーザーID */}
                <Form.Item
                  name="loginId"
                  label={<label style={{ fontSize: '14px', fontWeight: 'bold' }}>ユーザーID</label>}
                >
                  <Input style={{ width: '380px', height: '40px' }} placeholder="test@demo111.jp" />
                </Form.Item>
                {/*　旧パスワード */}
                <Form.Item
                  name="oldPassword"
                  label={<label style={{ fontSize: '14px', fontWeight: 'bold' }}>旧パスワード</label>}
                >
                  <Input style={{ width: '380px', height: '40px' }} type="password" placeholder="123456" />
                </Form.Item>
                {/* 新パスワード */}
                <Form.Item
                  name="newPassword"
                  label={<label style={{ fontSize: '14px', fontWeight: 'bold' }}>新パスワード</label>}
                >
                  <Input style={{ width: '380px', height: '40px' }} type="password" placeholder="123456" />
                </Form.Item>
                {/* ログインボタン */}
                <Form.Item style={{ textAlign: 'center' }}>
                  <Button
                    key="changePassword"
                    style={{
                      backgroundColor: '#e7c71ae3',
                      color: '#212529',
                      width: '80px',
                      height: '40px',
                      fontWeight: '600',
                      borderColor: '#808080',
                      borderWidth: '1px',
                    }}
                    type="primary"
                    htmlType="submit2"
                  >
                    完了
                  </Button>
                </Form.Item>
                {errorMessage != '' ? (
                  <Form.Item name="errorMessage">
                    <Alert
                      style={{ width: 450, textAlign: 'center', whiteSpace: 'pre-line' }}
                      message={errorMessage}
                      type="error"
                      showIcon
                    />
                  </Form.Item>
                ) : (
                  <></>
                )}
              </Form>
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
});

export default WithRouter(ChangePassword);
